import React from 'react';
import PropTypes from 'prop-types';
import ArrowBackIcon from './Icons/ArrowBackIcon';

/**
 * Reusable accessible back button component with loading state
 *
 * @param {Function} onClick - Click handler
 * @param {boolean} [disabled=false] - Disable button
 * @param {boolean} [isLoading=false] - Loading state
 * @param {string} [className=''] - Additional classes
 * @returns {JSX.Element} Back button component
 */
const BackButton = ({ onClick, disabled = false, isLoading = false, className = '', ...props }) => {
  const buttonText = isLoading ? 'Returning...' : 'Back';
  const isDisabled = disabled || isLoading;
  const ariaLabel = isLoading ? 'Processing return to previous page' : 'Go back to previous page';

  const baseButtonClasses = `flex items-center gap-4 text-xl text-custom-dark-gray`;

  const disabledClasses = `disabled:opacity-50 disabled:cursor-not-allowed`;

  const buttonClassName = `${baseButtonClasses} ${disabledClasses} ${className}`.trim();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={buttonClassName}
      aria-label={ariaLabel}
      {...props}
    >
      <ArrowBackIcon />
      <span>{buttonText}</span>
    </button>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

export default BackButton;
